import React, { useEffect, useState } from 'react'
import { useListContext, Toolbar, useTranslate } from 'react-admin'
import { ArrowBack, ArrowForward } from '@mui/icons-material'
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material'
import { LoadingButton } from '@mui/lab'
export const Paginator = ({
  lastIdsStack,
  setLastIdsStack,
  currentPage,
  setCurrentPage,
}) => {
  const { isFetching, data, setPerPage } = useListContext()
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const translate = useTranslate()

  // Capturar el `last_id` de los datos actuales y guardarlo en el stack
  useEffect(() => {
    if (data && data.length > 0 && !isFetching) {
      const lastId = data[data.length - 1]?.last_id // Extraer el last_id del último registro
      // Guardar el last_id asociado a la página actual (index = currentPage - 1)
      setLastIdsStack((prev) => {
        const next = [...prev]
        next[currentPage - 1] = lastId
        return next
      })
    }
  }, [data, currentPage, isFetching, setLastIdsStack])

  // Función para manejar página siguiente
  const handleNextPage = () => {
    // Solo avanzar si ya tenemos el cursor (last_id) de la página actual
    const currentIndex = currentPage - 1
    if (!lastIdsStack[currentIndex]) return

    setCurrentPage((prev) => prev + 1)
  }

  // Función para manejar página anterior y eliminar el `last_id` innecesario
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1)
      setLastIdsStack((prev) => prev.slice(0, -1)) // Eliminar el último last_id del historial
    }
  }

  // Función para manejar cambio de filas por página
  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = event.target.value || 10
    setRowsPerPage(newRowsPerPage) // Actualizar filas por página
    setPerPage(newRowsPerPage)
    setCurrentPage(1) // Reiniciar a la primera página
    setLastIdsStack([]) // Reiniciar historial de last_id
  }

  // Verificar si no hay más páginas hacia adelante
  const disableNextButton = !data || data.length === 0 || !data[data.length - 1]?.last_id

  return (
    <Toolbar sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
      <LoadingButton
        variant='outlined'
        disabled={currentPage === 1 || isFetching}
        onClick={handlePrevPage}
        loading={isFetching}
        size='small'
      >
        <ArrowBack fontSize='small' />
      </LoadingButton>
      <span>
        {translate('ra.navigation.page')} {currentPage}
      </span>
      <LoadingButton
        variant='outlined'
        disabled={isFetching || disableNextButton}
        onClick={handleNextPage}
        loading={isFetching}
        size='small'
      >
        <ArrowForward fontSize='small' />
      </LoadingButton>

      <FormControl size='small' sx={{ minWidth: 120, width: 200, marginLeft: 20 }}>
        <InputLabel id='rows-per-page-label'>{translate('ra.navigation.page_rows_per_page')}</InputLabel>
        <Select
          labelId='rows-per-page-label'
          value={rowsPerPage || 10}
          onChange={handleRowsPerPageChange}
          label={translate('ra.navigation.page_rows_per_page')}
          size='small'
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
    </Toolbar>
  )
}


